// This file defines exports from the builtin `JSON` constructor for internal
// use only.
/**
 * @internal
 */
const Builtin = JSON;
export { Builtin as JSON };
//# sourceMappingURL=builtin.js.map